<template>
	<div class="white-box">
		<h3 class="box-title">CLIENTES NUEVOS</h3>
		<line-chart :options="options" :chart-data="datacollection"></line-chart>
	</div>
</template>
<script>
	import LineChart from './../../../charts/basics/ChartLine.vue';
	export default {
		props: ['user', 'isAuth'],
		components: {
			LineChart,
		},
		data () {
			return {
				data: null,
				labels: [],
				series: [],

				datacollection: null,

				chart: null,

				options: {
					responsive: true,
					legend: {
						display: false,
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								callback: function (value) { if (Number.isInteger(value)) { return value; } },
								stepSize: 1
							}
						}]
					},
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/charts/new/customers/per/month')
				.then(response => {
					this.data = response.body
					this.loadData()
					//this.setTimeOut()
				})
			},
			loadData() {
				var that = this
				var labels = []
				var series = []

				$.each(this.data, function(index, value) {
					var date = moment(index).format('MMMM')
					var month = that.$options.filters.ucfirst(date)
					labels.push(month)
					series.push(value)
				})

				this.labels = labels

				var data = {
					label: 'Clientes',
					data: series
				}

				this.series = [data]

				this.datacollection = {
					labels: this.labels,
					datasets: this.series,
				}
			},
			setTimeOut() {
				var that = this
				setTimeout(function(){
					var time = moment().format('mm:ss')
					that.getData()
				}, 5000);
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/views/charts/newCustomersPerMonth.vue